import { lazy } from 'react';

export const LazyHubspotSelectTemplatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--hubspot-select-template-page" */ './hubspot-select-template-page'
    ),
);
